import {
  DirectSaleCartActionTypes,
  EMPTY_DIRECT_SALE_CART,
  REMOVE_DIRECT_SALE_PRODUCT,
  UPSERT_DIRECT_SALE_PRODUCT,
} from '../types';
import { IOrderProduct } from '../../types/orderProduct';

export const upsertDirectSaleProductAction = (productOrder: IOrderProduct): DirectSaleCartActionTypes => ({
  type: UPSERT_DIRECT_SALE_PRODUCT,
  payload: {
    productOrder,
  },
});

export const removeDirectSaleProductAction = (productOrderId: number): DirectSaleCartActionTypes => ({
  type: REMOVE_DIRECT_SALE_PRODUCT,
  payload: {
    productOrderId,
  },
});

export const emptyDirectSaleCartAction = (): DirectSaleCartActionTypes => ({
  type: EMPTY_DIRECT_SALE_CART,
});
